module.exports = __webpack_public_path__ + "img/四川天府新区西萌幼儿园.75bd4a20.jpg";